import { createPublicApiClient } from './client'

export interface SubmitContactFormData {
  name: string
  email: string
  subject: string
  message: string
}

export interface ContactFormResponse {
  success: boolean
  data: {
    id: string
    message: string
  }
}

// Contact form doesn't require authentication
const publicApiClient = createPublicApiClient()

export async function submitContactForm(
  data: SubmitContactFormData
): Promise<ContactFormResponse> {
  return publicApiClient.post<ContactFormResponse>('/contact', data)
}

